import { MOBILE_SIZE, TABLET_SIZE } from "constant/DisplaySize";
import React from "react";
import { useMediaQuery } from "react-responsive";
import PcPage from "components/hotdesking/pc/Page";
import MobilePage from "components/hotdesking/mobile/Page";

function HotDesking() {
  const isMobile = useMediaQuery({ query: MOBILE_SIZE });
  const isTablet = useMediaQuery({ query: TABLET_SIZE });
  return <>{isMobile || isTablet ? <MobilePage /> : <PcPage />}</>;
}

export default HotDesking;
